import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "rc-pageMsg" };
const _hoisted_2 = ["textContent"];
import SvgIcon from "@/common/components/SvgIcon.vue";
// Setup
export default /*@__PURE__*/ _defineComponent({
    __name: 'PageMessage',
    props: {
        label: {},
        icon: { default: undefined },
        background: { default: "var(--s-d-5)" }
    },
    setup(__props) {
        _useCssVars(_ctx => ({
            "v0dcf4f40": (_ctx.background)
        }));
        /********************************************
         * PageMessage Component
         *
         * Props:
         * 	label (required) - text label on message
         *  icon - path to sprite
         *  background - background color
         *
         *********************************************/
        // Components
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (__props.icon)
                    ? (_openBlock(), _createBlock(SvgIcon, {
                        key: 0,
                        icon: __props.icon
                    }, null, 8, ["icon"]))
                    : _createCommentVNode("", true),
                _createElementVNode("span", {
                    textContent: _toDisplayString(__props.label)
                }, null, 8, _hoisted_2)
            ]));
        };
    }
});
